import axios from "axios";
import { Sentry } from "@/lib/sentry";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("arissai_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Token invalid – clear and let routes redirect
      localStorage.removeItem("arissai_token");
      localStorage.removeItem("arissai_user");
    } else if (!err.response || err.response.status >= 500) {
      // Server errors + network failures → Sentry (skip 4xx client errors / expected validation)
      Sentry.captureException(err);
    }
    return Promise.reject(err);
  }
);

export default api;
